"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var SupplierAgreementWarningFlag_1 = require("../../supply/model/SupplierAgreementWarningFlag");
/** @author PKr */


var SupplierAgreementTransferValidationDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SupplierAgreementTransferValidationDTO, _DomainObject_1$Domai);

  /**
   * @param supplierId
   * @param supplierAgreementId
   * @param windowItemId
   * @param flags - validation flags per product id
   */
  function SupplierAgreementTransferValidationDTO(supplierAgreementId, windowItemId, supplierId, flags) {
    var _this;

    _classCallCheck(this, SupplierAgreementTransferValidationDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementTransferValidationDTO).call(this));
    _this.supplierAgreementId = supplierAgreementId;
    _this.windowItemId = windowItemId;
    _this.supplierId = supplierId;
    _this.flags = flags;
    return _this;
  }

  return SupplierAgreementTransferValidationDTO;
}(DomainObject_1.DomainObject);

exports.SupplierAgreementTransferValidationDTO = SupplierAgreementTransferValidationDTO;

SupplierAgreementTransferValidationDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SupplierAgreementTransferValidationDTO.name);
  return {
    supplierAgreementId: builder.str('supplierAgreementId'),
    windowItemId: builder.str('windowItemId'),
    supplierId: builder.str('supplierId'),
    flags: builder.flags('flags', SupplierAgreementWarningFlag_1.SupplierAgreementWarningFlag)
  };
}();